import templateUrl from 'emun.salesrep/salesrep-sales-category-quarter.htm'
import salesrepConfig from 'emun.salesrep/salesrep.config'

class SalesRepSalesCategoryQuarterController {
    constructor($window, $rootScope, retailerPrompt, createAutoQuery) { 
        let $ctrl = this;
        this.categoryChartLabels = ['Jan-Mar', 'Apr-Jun', 'Jul-Sep', 'Oct-Dec'];
        this.categoryChartSeries = [];
        var filter = "SalesRepID";
        if ($ctrl.context == 'manager') { filter = "ManagerId";}
        if ($ctrl.context == 'executive') {filter = '';}
		$ctrl.colors = salesrepConfig.chartColors;
        $ctrl.chartOptions = { 
            maintainAspectRatio: true,
            legend: { 
                display: true,
                labels: {
                    boxWidth: 5,
                    fontSize: 10
                }

            },
            elements: {
                rectangle: {
                    borderWidth: 1
                }
            },
            scales: {
                yAxes: [{
                    display: true,
                    ticks: {
                        callback: function(value, index, values) {
                            return '$' + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                        },
                        fontSize: 11
                    }
                }]
            },
            tooltips: {
                enabled: true,
                callbacks: {
                    label: function(tooltipItem, data) {
                        var label = data.datasets[tooltipItem.datasetIndex].label ;
                        var datasetLabel = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                        return label + ": $" + datasetLabel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                        //                        return label + ': ' + $filter('currency')(datasetLabel);
                    }
                }
            },
        }

        $ctrl.categoryChartData = [];
        var today = new Date();
        $ctrl.loadCategoryChartData = function(args) {
            this.categoryChartLabels = ['Jan-Mar', 'Apr-Jun', 'Jul-Sep', 'Oct-Dec'];
            this.categoryChartSeries = [];
            this.categoryChartData = [];
            let $ctrl = this;
            var flags = [];
            args.forEach(function(obj) {
                if(!flags[obj.category]) {
					flags[obj.category] = true;
					$ctrl.categoryChartSeries.push(obj.category);
                }
            });
            $ctrl.categoryChartSeries.forEach(function(series) {
                var result = args.filter(function( obj ) {
					return obj.category == series;
                });
                var categorySeriesData = [0,0,0,0];
                result.forEach(function(obj) {
                    categorySeriesData[obj.quarter - 1] = Math.round(obj.total);
                });
                $ctrl.categoryChartData.push(categorySeriesData);
                $ctrl.chartLoaded = true;
            });
        }
        var url = 'QuerySalesDailyCategoryTotals.json?Sum=SalesDailyTotal&GroupBy=Category,Quarter&OrderBy=Quarter&dateRange=YTD';
        if ($ctrl.repGroup) {
            if ($ctrl.repGroup != 'ALL') {
                url = url + '&RepGroupName=' + $ctrl.repGroup;
            }
        }
        if (filter != '') {
            url = url + '&' + filter + '=' + $ctrl.rep.id;
        }
        var quarterlySales = createAutoQuery({
            url: url,
            autoLoad: true,
            pageSize: 1000,
            onLoaded: function(args) {
				var results = [];
				var quarters = [1,2,3,4];
				quarters.forEach(function (q) {
//					var data = _.where(args.results, { quarter: q });
					var data = args.results.filter(r => r.quarter == q);
					var dataSorted = _.sortBy(data || [], '-sumSalesDailyTotal');
					if (dataSorted.length > 0) {
						var maxColumn = dataSorted.length > 6 ? 6 : dataSorted.length;
						for (var i = 0; i < maxColumn; i++) {
							var res = dataSorted[i];
							var obj = {
								total: 0,
								category: '',
								quarter: 0
							};
							obj.category = res.category;
							obj.total += res.sumSalesDailyTotal;
							obj.quarter = res.quarter;
							results.push(obj);
						}
					}
				});

                $ctrl.loadCategoryChartData(results);
            }
        });
    }
}

let SalesRepSalesCategoryQuarter = {
    bindings: {
        rep: '<',
        repGroup: '@',
        context: '@'
    },
    controller: SalesRepSalesCategoryQuarterController,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
}

export default SalesRepSalesCategoryQuarter